<script setup>
import { useRouter } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const router = useRouter();

const openProfileSettings = () => {
  return router.push({ name: 'profile_settings_index' });
};
</script>

<template>
  <div
    class="flex items-center gap-1.5 w-fit max-w-full my-1 ps-2.5 pe-1 py-0.5 rounded-full bg-n-alpha-2 text-xs text-n-slate-11"
  >
    <Icon icon="i-ph-signature" class="size-3.5 flex-shrink-0" />
    <span class="truncate">
      {{ $t('CONVERSATION.FOOTER.SIGNATURE_MISSING') }}
    </span>
    <Button
      link
      xs
      :label="$t('CONVERSATION.FOOTER.SIGNATURE_CONFIGURE')"
      class="!text-xs"
      @click="openProfileSettings"
    />
  </div>
</template>
